<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">상품조회</span>
      <button class="btn-pop-close" @click="$.emit('close')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <!-- 20231018 수정: 상단 폼 수정 -->
      <div class="fieldset">
        <span class="h2">영수증 조회</span>
        <div class="ip-row">
          <!-- 라디오 -->
          <div class="custom-radio--type02">
            <input
              type="radio"
              name="rcType"
              value="1"
              id="rcType01"
              label="상품명"
              checked
            />
            <label for="rcType01">상품명</label>
          </div>
          <div class="custom-radio--type02">
            <input
              type="radio"
              name="rcType"
              value="2"
              id="rcType02"
              label="바코드"
            />
            <label for="rcType02">바코드</label>
          </div>
          <!-- //라디오 -->
          <input
            type="text"
            class="ip-comm ip-md left"
            id=""
            v-model="searchWord"
          />
          <button
            type="button"
            class="btn-smd02 btn-main"
            @click="searchMenu()"
          >
            조회<span class="overlay"></span>
          </button>
        </div>
      </div>
      <div class="flex">
        <!-- 20231018 수정: 테이블 내 버튼 제거, 버튼은 하단으로 이동 -->
        <table class="tb-lst-payment tb-product">
          <thead>
            <tr>
              <td>No</td>
              <td>상품명</td>
              <td>금액</td>
            </tr>
          </thead>
          <tbody id="tb-product-tbody">
            <tr
              v-for="(menu, index) in menuList"
              :key="index"
              :class="{ on: activeMenu == index }"
              @click="activeMenu = index"
            >
              <td>{{ index + 1 }}</td>
              <td>
                <span>{{ menu.name }}</span
                ><span></span>
              </td>
              <td>
                {{
                  menu.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tb-side-btn">
          <button type="button" class="btn-side-up" @click="scroll(-33)">
            위로<span class="overlay"></span>
          </button>
          <button type="button" class="btn-side-down" @click="scroll(33)">
            아래로<span class="overlay"></span>
          </button>
        </div>
        <div class="info-box">아래로 스크롤해 주세요</div>
      </div>
    </div>
    <div class="pop-btn-area">
      <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
      <button type="button" class="btn-pop btn-fourth btn-main">
        자세히 보기<span class="overlay"></span>
      </button>
      <button
        type="button"
        class="btn-pop btn-half btn-submit"
        @click="registProd()"
      >
        상품등록<span class="overlay"></span>
      </button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "productSearch",
  props: {},
  data() {
    return {
      menuList: [],
      activeMenu: -1,
      searchWord: "",
    };
  },
  methods: {
    scroll(heigth) {
      let table = document.getElementById("tb-product-tbody");
      let scrollTop = table.scrollTop;

      table.scroll(0, scrollTop + heigth);
    },
    searchMenu() {
      let list = _.cloneDeep(this.$store.getters.getMenuList);
      if (this.searchWord.trim() == "") {
        this.menuList = list;
        return false;
      }

      // 체크된 라디오 버튼을 찾습니다.
      var radioGroup = document.getElementsByName("rcType");
      var checkedRadio = null;
      for (var i = 0; i < radioGroup.length; i++) {
        if (radioGroup[i].checked) {
          checkedRadio = radioGroup[i];
          break;
        }
      }

      if (checkedRadio.value == "1") {
        this.menuList = list.filter((item) => {
          return item.name.indexOf(this.searchWord) >= 0;
        });
      } else {
        this.menuList = list.filter((item) => {
          return item.name.indexOf(this.searchWord) >= 0;
        });
      }
    },
    registProd() {
      if (this.activeMenu == -1) return false;
      this.$.emit("optionModal", this.menuList[this.activeMenu]);
      this.$.emit("close");
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


